import React from 'react'
import SavingsSlide from './SavingsSlide'
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import TrackSavingsOnTheGo from '../../components/TrackSavingsOnTheGo';
const Savings = () => {
  return (
    <div>
  <SavingsSlide/>

  <Container>
<Row>
    <Col lg={4}><h1 className='h1 py-5 gn-title'>High Yield Savings Account</h1></Col>

    <Col lg={8}>
    <p className='py-5 my-3 card-text'>Your GN Bank Savings Account comes equipped with features to help you save even more money with every deposit.Funds are FDIC insured up to $250,000, so you can rely on your savings.</p>
    </Col>
</Row>

  </Container>






  <section className="benefits-section bg-light py-5">
          <Container>
            <h2 className="text-center mb-4 h3 gn-title">Key Benefits?</h2>
            <Row>
              <Col md={4}>
                <Card className="h-100 shadow-sm">
                  <Card.Body>
                    <Card.Title>No Monthly Fees</Card.Title>
                    <Card.Text>
                      Enjoy a hassle-free banking experience with no monthly maintenance fees.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card className="h-100 shadow-sm">
                  <Card.Body>
                    <Card.Title>Overdraft Protection</Card.Title>
                    <Card.Text>
                      Stay protected with options to cover overdrafts on your account.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card className="h-100 shadow-sm">
                  <Card.Body>
                    <Card.Title>Mobile Banking</Card.Title>
                    <Card.Text>
                      Manage your account anytime, anywhere with our mobile app.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>





{/* Call to Action Section */}
      <section className="cta-section py-5 text-center bg-darks text-white">
        <Container>
          <h2>Ready to Open Your Account?</h2>
          <p className="lead text-center text-white">
            Start your journey to better banking today.
          </p>
          <div className='gn-button-div'>
          <Button  size="lg" onClick={() => {}} className='gn-button'>
            Open an Account
          </Button>
          </div>
        </Container>
      </section>


{/* <TrackSavingsOnTheGo/> */}



       {/* Benefits Section */}
            {/* <section className="benefits-section py-5">
              <Container>
                <h2 className="text-center mb-4 h3 gn-title">Key Features?</h2>
                <Row>
                  <Col md={4}>
                    <Card className="h-100 shadow-sm">
                      <Card.Body>
                        <Card.Title>No Monthly Fees</Card.Title>
                        <Card.Text>
                          Enjoy a hassle-free banking experience with no monthly maintenance fees.
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={4}>
                    <Card className="h-100 shadow-sm">
                      <Card.Body>
                        <Card.Title>Overdraft Protection</Card.Title>
                        <Card.Text>
                          Stay protected with options to cover overdrafts on your account.
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={4}>
                    <Card className="h-100 shadow-sm">
                      <Card.Body>
                        <Card.Title>Mobile Banking</Card.Title>
                        <Card.Text>
                          Manage your account anytime, anywhere with our mobile app.
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </section> */}
      
            {/* Features Section */}
            {/* <section className="features-section  py-5 ">
              <Container>
                <h2 className="text-center mb-4 gn-title">Key Features</h2>
                <Row className='text-justify gn-row'>
                  <Col md={4}>
                  <Card className="h-100 shadow-sm">
                      <Card.Body>
                        <Card.Title>Free Online Bill Pay</Card.Title>
                        <Card.Text>
                          Pay Bill Directly using our website or mobile app
                        </Card.Text>
                      </Card.Body>
                    </Card>
                 
                  </Col>
                  <Col md={4}>
      
                  <Card className="h-100 shadow-sm">
                      <Card.Body>
                        <Card.Title>Secure Online Access</Card.Title>
                        <Card.Text>
                          Pay Bill Directly using our website or mobile app
                        </Card.Text>
                      </Card.Body>
                    </Card>
                 
                  </Col>
      
                  <Col md={4}>
      
                  <Card className="h-100 shadow-sm">
                      <Card.Body>
                        <Card.Title>FDIC Insured</Card.Title>
                        <Card.Text>
                          Up to 250,000
                        </Card.Text>
                      </Card.Body>
                    </Card>
                 
                  </Col>
                </Row>
      
      
      
      
      
            
      
      
      
              </Container>
            </section> */}





  </div>
  )
}

export default Savings